var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Values',{attrs:{"value":_vm.value,"chart-values":_vm.chartValues,"mode":_vm.legitMode}})}
var staticRenderFns = []

export { render, staticRenderFns }